<h4>Deseja realmente realizar o cancelamento?</h4>
<div class="separator"></div>
<div class="container-table">
    <!-- <button class="close-btn btn btn-outline-primary btn-style-planetun" mat-button mat-dialog-close>X</button> -->

    <app-input-select *ngIf="data.cancelReasons?.length > 0" name="cancelReason" [formGroup]="form" [className]="'error'"
        controlName="cancelReasons" title="motivos" [classInfo]="hasErrorReason ? 'error' :''"
        [values]="data.cancelReasons">
    </app-input-select>
    <div style="margin-top: 4%;">
        <button (click)="cancel()" type="button" class="remove-button cancel-remove mr-4" value="nao">Não</button>
        <button (click)="submit()" type="button" class="send-button cancel-send" value="sim">Sim</button>
    </div>

</div>